import React from "react";
import FastLink from "./link";

// import data from "./data";
import "./style.scss";

const FastLinks = ({ data, parentCategory }) => {
  return (
    <div class="fast-links fast-links--alt">
      {data.map((link) => (
        <FastLink {...link} parentCategory={parentCategory} />
      ))}
    </div>
  );
};

export default FastLinks;
